// extracted by mini-css-extract-plugin
export default {"pdp-invisible_container":"pdp-invisible_container","has-focus":"has-focus","has-focus-mouse":"has-focus-mouse","disable_tabNav_styles":"disable_tabNav_styles"};